/* eslint-disable */

import axios from '../../../shared/utils/axios-init';

const state = () => ({
  data: {},
  loading: true,
});

const getters = {
  getBannerData(state) {
    return state.data;
  },
  getLoading(state) {
    return state.loading;
  }
}

const actions = {
  async fetchCurrencyData({ commit }, credentials) {
    try {
      commit('setLoading');
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const params = {
        couple: { 
          'base': credentials.couple.baseCurrency, 
          'quoted': credentials.couple.quoteCurrency,
        },
        timestamp: Date.now(),
        market_quoted: credentials.selectedQuated,
      };

      if (credentials.isInit) {
        params.dealstat = 1;
      }

      const { data } = await axios.post(
        '/dashboard/update',
        JSON.stringify(params),
        { headers: { Authorization: `Bearer ${token}` } }
      );

      commit('setBannerState', data.dealstat);
    } catch (e) {
      console.log(e);
    }
  },
};

const mutations = {
  setBannerState(state, payload) {
    state.data = payload;
    state.loading = false;
  },
  setLoading(state) {
      state.loading = true;
  },
};


export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/modules/Dashboard/modules/banner.js